import React, { useEffect, useMemo, useState } from "react";
import { Col, Row, Card, Button, Flex, Tag, Modal, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../hooks/useAuth";
import Search from "antd/es/input/Search";
import useShiftbats from "../hooks/useShiftbats";
import useRegions from "../hooks/useRegions";

export default function ShiftbatItems() {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchKey, setSearchkey] = useState("");
  const [activeTab, setActiveTab] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const { auth } = useAuth();
  const dispatch = useDispatch();

  const organisation = useSelector((state) => state.organisation.organisation);
  const { data, status, error } = useShiftbats(auth, dispatch);
  const regions = useRegions(organisation);

  const getAllCategories = useMemo(() => {
    if (!data || data.length === 0) return [];
    const categories = data[0].attributes?.shiftbats
      ?.map((item) => item.categories.data?.map((category) => category.attributes.name))
      .flat();
    return [...new Set(categories)];
  }, [data]);

  const shiftbatsByRegion = useMemo(() => {
    const _d = {};
    data?.forEach((i) => {
      if (!_d[i.region.region_id]) {
        _d[i.region.region_id] = [];
      }
      if (
        i?.region?.region_id &&
        (i.shiftBatName.toLowerCase().includes(searchKey.toLowerCase()) || i.shiftBatNumber.toLowerCase().includes(searchKey.toLowerCase()))
      ) {
        _d[i.region.region_id].push(i);
      }
    });

    // sort all the shiftbats by shiftBatNumber
    Object.keys(_d).forEach((key) => {
      _d[key] = _d[key].sort((a, b) => {
        if (a.shiftBatNumber < b.shiftBatNumber) {
          return -1;
        }
        if (a.shiftBatNumber > b.shiftBatNumber) {
          return 1;
        }
        return 0;
      });
    });
    return _d;
  }, [data, searchKey]);

  useEffect(() => {
    if (Object.keys(shiftbatsByRegion).length > 0 && !activeTab) {
      setActiveTab(Object.keys(shiftbatsByRegion)[0]);
    }
  }, [shiftbatsByRegion, activeTab]);

  if (status === "pending" || data === null) return <div className="AlertInfo Loading">Loading...</div>;
  if (error) return <p>Error :(</p>;

    console.log('>>>> data', data)

  if (data?.length === 0) return <p>No driver duties found</p>;

  const openFile = (item) => {
    setIsModalOpen(true);
    const region = item.region.region_id;
    const shiftbatId = item.shiftBatId;
    const url = `${process.env.REACT_APP_BUSABLE_APP_URL}/p_sb/${region}/${shiftbatId}`;
    setSelectedItem(url);
  };

  const handleOnTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <div>
      <Search
        size="large"
        placeholder="Search driver duties"
        allowClear
        onChange={(event) => setSearchkey(event.target.value)}
        enterButton
        value={searchKey}
        style={{marginBottom: "20px"}}
      />
      <Flex wrap="wrap" style={{ marginTop: "30px" }} className="FilterTags">
        {getAllCategories?.map((category) => (
          <Tag
            color="default"
            key={category}
            className={selectedCategories.includes(category.toLowerCase()) ? "Active" : null}
            onClick={() => {
              if (selectedCategories.includes(category.toLowerCase())) {
                setSelectedCategories(selectedCategories.filter((item) => item !== category.toLowerCase()));
              } else {
                setSelectedCategories([...selectedCategories, category.toLowerCase()]);
              }
            }}
          >
            {category}
          </Tag>
        ))}
      </Flex>
      <Tabs
        defaultActiveKey={activeTab}
        onChange={handleOnTabChange}
        items={Object.keys(regions).map((regionId) => {
          return {
            key: regionId,
            label: regions[regionId]?.region_name,
            children: (
              <>
                <Row gutter={[20, 20]} style={{ marginTop: "50px" }}>
                  {shiftbatsByRegion?.[regionId]?.length === 0 || !shiftbatsByRegion?.[regionId] && <p>No driver duties found</p>}
                  {shiftbatsByRegion?.[regionId]?.filter((item) => item.published === 1).map((item) => (
                    <Col span={24}>
                      <div className="CardDocumentsWrap">
                        <Card onClick={() => openFile(item)} className="CardItem CardDocuments">
                          <h3>
                            {item.shiftBatNumber}
                            {": "}
                            {item.shiftBatName} {item.charter ? `Charter` : null}
                          </h3>
                        </Card>
                        <Button shape="round" onClick={() => openFile(item)}>
                          View
                        </Button>
                      </div>
                    </Col>
                  ))}
                </Row>
              </>
            ),
          };
        })}
      />
      <Modal
        title="Driver Duty Detail"
        onOk={() => {
          setIsModalOpen(false);
        }}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        cancelButtonProps={{ style: { display: "none" } }}
        open={isModalOpen}
        width={1100}
      >
        {selectedItem && <iframe src={selectedItem} style={{ width: "100%", height: "800px", border: "none" }} title="Driver Duty Detail" />}
      </Modal>
    </div>
  );
}
